export default "<header>\n    <div class=\"title\">Apertura de siniestros Hiper Usera</div>\n</header>\n"